export const saveRightOrderDomains = (data, domains) => {
  if (domains.length !== data.length) return data
  return domains.map(domain => {
    return data.filter(dataItem => dataItem.domainName === domain)[0]
  })
}
